import { useState } from 'react'
import { haptic } from '../lib/telegram'
import { useSirr } from '../store'
import { Match } from './astro/Match'
import { Natal } from './astro/Natal'
import { Daily } from './astro/Daily'

export function Compat() {
  const { t } = useSirr()
  const [tab, setTab] = useState<'daily' | 'match' | 'natal'>('daily')

  return (
    <div className="screen" style={{ paddingTop: 18 }}>
      <div
        style={{
          display: 'flex',
          gap: 8,
          marginBottom: 20,
          border: '1px solid rgba(200,162,78,.2)',
          borderRadius: 12,
          padding: 4,
        }}
      >
        {(['daily', 'match', 'natal'] as const).map((id) => (
          <button
            key={id}
            type="button"
            aria-pressed={tab === id}
            onClick={() => {
              haptic.select()
              setTab(id)
            }}
            style={{
              flex: 1,
              textAlign: 'center',
              padding: 9,
              borderRadius: 9,
              fontSize: 12,
              fontWeight: 600,
              background: tab === id ? 'var(--gold-gradient)' : 'transparent',
              color: tab === id ? '#160c28' : 'var(--ink-muted)',
            }}
          >
            {t(id === 'daily' ? 'dailyTitle' : id === 'match' ? 'compat' : 'natal')}
          </button>
        ))}
      </div>

      {/* Экраны размонтируются при переключении — так каждый заново объявляет
          свою главную кнопку и не остаётся чужого расчёта на виду. */}
      {tab === 'daily' ? <Daily /> : tab === 'match' ? <Match /> : <Natal />}
    </div>
  )
}
